import { ErrorHandler } from "../../Editor/services/error-handler";
import { HttpHeaders } from "../../../utils/http-utils";
import { curriedGet } from "../../Editor/services/abort-controller";

export class UserService {
  private static errorHandler = new ErrorHandler("User service");

  private static readonly apiUrl = "/api/user/current";

  private static config: {
    baseURL: string;
    timeout: number;
    headers: HttpHeaders;
  };

  private static baseURL: string;

  constructor(baseURL: string) {
    UserService.baseURL = baseURL;
    UserService.config = {
      baseURL: UserService.baseURL,
      timeout: 3000,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
  }

  public static async fetchCurrentUser() {
    const requestPromise = curriedGet(UserService.apiUrl, UserService.config);
    const res = await requestPromise;
    return res.data;
  }
}
